import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import { studentFetchStudentMissions, } from '../../services2/pstudentMissions.service';
import MissionResult from '../primary_admin/components/MissionResult.js';
import { fetchSchoolMissions } from '../../services2/pschoolMissions.service.js';

function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [mission, setmission] = useState(null)
    const [schoolMission, setschoolMission] = useState(null)
    const [isLoading, setisLoading] = useState(false)

    const fetchMission = async () => {
        let result = await studentFetchStudentMissions(props.token.token, { _id: id });
        if (result.result) {
            setmission(result.result?.[0] || null)
            fetchSchoolMission(result.result?.[0]?.missionId)
        } else {
            alert('Fetch data error')
        }
    }

    const fetchSchoolMission = async (missionId) => {
         let result = await fetchSchoolMissions(props.token.token,{missionId},{limit:1});
        if (result.result) {
            setschoolMission(result.result?.[0] || null)
        } else {
            console.log('Fetch data error')
        }
    }

    const refresh = async () => {
        if (isLoading) return
        setisLoading(true)
        await fetchMission()
        setisLoading(false)
    }

    useEffect(() => {
        refresh()
    }, [id])

    return (
        <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex text-[16px] text-[black]' style={{ overflowY: "auto" }}>
            <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap pl-[16px] pt-[16px]'>
                <div className='text-[#1D1D41] text-[24px] font-[400] cursor-pointer' onClick={() => { navigate(`/platform2/records`) }}>{`<`} 返回</div>
                {schoolMission?.disableAnswer?<div/>:<div className='cursor-pointer underline text-[#1F4CC8] text-[14px] font-[700] mr-[24px]' onClick={() => { navigate(`/platform2/studentreports/${id}`) }}>
                    學生閱讀成績單
                </div>}
            </div>
            <MissionResult mission={mission} setmission={setmission}/>

        </div>
    )

}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
